import React, { useMemo } from 'react'

import {
  MAX_CONTENT_WIDTH_FULL,
  resolveMobileMargin,
  useEditor
} from '@toasttab/sites-components'

import { PageType } from 'src/apollo/sites'
import { useOptionalRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'

import { spacingEnumToVw } from 'public/components/default_template/dynamic_section/DynamicSectionUtils'

export const useWebsiteLayoutSpacing = (): React.CSSProperties => {
  const { isEditor } = useEditor()
  const restaurantContext = useOptionalRestaurant()
  const restaurant = restaurantContext?.restaurant
  const currentPageType = restaurantContext?.currentPageType

  return useMemo(() => {
    // oo pages have no type
    const isWebsitePage =
      currentPageType != null && currentPageType !== PageType.Ecommerce
    if (!isWebsitePage) {
      return {}
    }

    const designConfig = restaurant?.config?.designConfig
    const marginVw = spacingEnumToVw(designConfig?.horizontalSpacing)
    const maxContentWidth = designConfig?.maxContentWidth

    const vars: Record<string, string> = {}
    if (marginVw > 0) {
      vars['--website-inset-desktop'] = `${marginVw}vw`
      vars['--website-inset-mobile'] = `${resolveMobileMargin(
        marginVw,
        isEditor
      )}vw`
    }
    if (maxContentWidth && maxContentWidth > MAX_CONTENT_WIDTH_FULL) {
      vars['--website-max-content-width'] = `${maxContentWidth}px`
    }
    return vars as React.CSSProperties
  }, [
    currentPageType,
    isEditor,
    restaurant?.config?.designConfig?.horizontalSpacing,
    restaurant?.config?.designConfig?.maxContentWidth
  ])
}
